var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_7914)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2229 1.0284C9.71237 2.89527 7.44837 4.00002 5.00108 4.00002C4.55002 4.00002 4.1041 3.96278 3.66626 3.88929C3.05636 3.78693 2.50073 4.25714 2.50073 4.87558L2.50124 11.3027L2.50642 11.6522C2.62103 15.4336 4.49897 18.9305 7.58056 21.1059L11.4236 23.819C11.7694 24.063 12.2313 24.063 12.5771 23.819L16.4201 21.1059L16.7027 20.9001C19.7258 18.6256 21.4995 15.0748 21.4995 11.3026L21.5 4.87558C21.5 4.25714 20.9443 3.78693 20.3344 3.88929C19.8966 3.96278 19.4507 4.00002 18.9996 4.00002C16.5523 4.00002 14.2883 2.89528 12.7777 1.02838C12.3774 0.533745 11.6231 0.533755 11.2229 1.0284ZM12 3.14002L12.0872 3.2262C13.9233 4.98446 16.3789 6.00002 18.9996 6.00002L19.4201 5.99132L19.5 5.98602L19.4995 11.3026C19.4995 14.446 18.0214 17.4052 15.5124 19.2929L15.2544 19.4809L12 21.778L8.734 19.472C6.16603 17.6592 4.60106 14.7451 4.50585 11.6067L4.50112 11.2875L4.49997 5.98602L4.58059 5.99132C4.72037 5.99712 4.86055 6.00002 5.00108 6.00002C7.62179 6.00002 10.0774 4.98445 11.9134 3.22618L12 3.14002Z",
    fill: "#232631"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_7914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.a3317dae7aef0ba8bdcaca7ed4a5c165.svg";
export { ForwardRef as ReactComponent };